import React from 'react';
import styles from './index.module.css';

const DEFAULT_ELEMENT = {
  heading4xl: 'h1',
  heading3xl: 'h1',
  heading2xl: 'h2',
  headingXl: 'h2',
  bodyLg: 'p',
  bodyBase: 'p',
  bodyBaseMedium: 'p',
  bodySmSemibold: 'span',
  uiSm: 'span',
  uiXs: 'span',
};

const Typography = ({ variant = 'bodyBase', as, align = 'left', color, className, children, ...rest }) => {
  const Element = as || DEFAULT_ELEMENT[variant] || 'span';
  const alignClass = {
    left: styles.alignLeft,
    center: styles.alignCenter,
    right: styles.alignRight,
  }[align];
  const variantClass = styles[variant];
  const classes = [styles.base, variantClass, alignClass, className].filter(Boolean).join(' ');
  const style = color ? { color, ...(rest.style || {}) } : rest.style;
  return (
    <Element {...rest} style={style} className={classes}>
      {children}
    </Element>
  );
};

export default Typography;
